import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7db39d94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title grid__item py-3 w-content gordita-400-12 text-Text/text_medium" }
const _hoisted_2 = ["data-testid", "data-value"]


import { Maybe } from 'graphql/jsutils/Maybe';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';

type Entry = {
  title: string;
  value: Maybe<string>;
  dataTestId: string;
  dataOriginalValue?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-summary-block-entries',
  props: {
    entries: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-summary-block-content-entries w-full grid" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.entries || [], (prop, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(prop.title), 1),
          _createElementVNode("div", {
            class: "value grid__item py-3 text-Text/text_high gordita-400-12",
            "data-testid": prop.dataTestId,
            "data-value": prop.dataOriginalValue || prop.value
          }, _toDisplayString(prop.value), 9, _hoisted_2)
        ], 64))
      }), 128))
    ]),
    _: 1
  }))
}
}

})